import { coerceBooleanProperty } from "@angular/cdk/coercion";
import {
  Attribute,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  Optional,
  ViewEncapsulation
} from "@angular/core";

export type EneButtonSize = "small" | "medium" | "large" | "xlarge";
export type EneButtonColor = "accent" | "primary" | "dark";
export type EneButtonTypes = "ene-default-button" | "ene-filled-button" | "ene-outline-button";

const BUTTON_HOST_ATTRIBUTES: ReadonlyArray<EneButtonTypes> = [
  "ene-default-button",
  "ene-filled-button",
  "ene-outline-button"
];

@Component({
  // tslint:disable-next-line: component-selector
  selector: "button[ene-button], button[ene-outline-button], button[ene-filled-button]",
  templateUrl: "button.component.html",
  styleUrls: ["button.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  // tslint:disable-next-line: no-host-metadata-property
  host: {
    "[attr.disabled]": "disabled || null",
    "[class.ene-icon-button]": "icon",
    "[class.right-icon]": "_rightIcon",
    "[class]": "getButtonClasses(size, color, _buttonClass)"
  }
})
export class EneButtonComponent {
  @Input() public icon: string | undefined;
  @Input() public loading: boolean = false;
  @Input() public disabled: boolean = false;
  @Input() public size: EneButtonSize = "medium";
  @Input() public color: EneButtonColor = "accent";

  public _rightIcon: boolean = false;
  public _buttonClass: string = "ene-default-button";

  constructor(
    @Optional() @Attribute("rightIcon") private readonly rightIcon: boolean,
    private readonly elementRef: ElementRef
  ) {
    this._rightIcon = coerceBooleanProperty(this.rightIcon);

    BUTTON_HOST_ATTRIBUTES.forEach((attribute) => {
      if (this.hasHostAttribute(attribute)) {
        this._buttonClass = attribute;
      }
    });
  }

  public getButtonClasses(...classes: Array<string>): string {
    return ["ene-button", ...classes].join(" ");
  }

  private get hostNativeElement(): HTMLElement {
    return this.elementRef.nativeElement;
  }

  private hasHostAttribute(...attributes: Array<string>): boolean {
    return attributes.some((attribute) => this.hostNativeElement.hasAttribute(attribute));
  }
}
